import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { sessionDetailSearchSchema } from "./-lib/search-schema";



export const Route = createFileRoute("/_protected/class-sessions/$sessionId/")({
  head: () => ({
    meta: [{ title: "班期详情 · imiker CRM" }],
  }),
  validateSearch: sessionDetailSearchSchema,
  search: {
    middlewares: [stripSearchParams({ tab: "students" as const })],
  }
});
